export const swappables = {
  entities: [
    [
      'transport-belt',
      'fast-transport-belt',
      'express-transport-belt',
      'turbo-transport-belt',
    ],
    [
      'underground-belt',
      'fast-underground-belt',
      'express-underground-belt',
      'turbo-underground-belt',
    ],
    ['splitter', 'fast-splitter', 'express-splitter', 'turbo-splitter'],
    [
      'burner-inserter',
      'inserter',
      'long-handed-inserter',
      'fast-inserter',
      'bulk-inserter',
      'stack-inserter',
    ],
    ['assembling-machine-1', 'assembling-machine-2', 'assembling-machine-3'],
    ['stone-furnace', 'steel-furnace'],
    ['lightning-rod', 'lightning-collector'],
  ],
  tiles: [
    [
      'stone-brick',
      'concrete',
      'hazard-concrete',
      'refined-concrete',
      'refined-hazard-concrete',
    ],
  ],
  items: [
    ['effectivity-module', 'effectivity-module-2', 'effectivity-module-3'],
    ['efficiency-module', 'efficiency-module-2', 'efficiency-module-3'],
    ['speed-module', 'speed-module-2', 'speed-module-3'],
    ['productivity-module', 'productivity-module-2', 'productivity-module-3'],
    ['quality-module', 'quality-module-2', 'quality-module-3'],
  ],
};
